import esContent from './menu.es';

export default {
  ...esContent,
};
